import { format } from 'date-fns'

export default {
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
    ordersInProgress: []
}

function setInitialFilters() {
    return {
        date__gte: format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY-MM-DD'),
        date__lte: null,
    }
}

